module.exports = __webpack_public_path__ + "static/mask-7f8ff822e186078e1c957d7cc3bc17a2.png";